import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = ({ faqs, bookmarkedArticles, onBookmark }) => {
  const [expandedFAQ, setExpandedFAQ] = useState(null);
  const [ratings, setRatings] = useState({});

  const toggleFAQ = (faqId) => {
    setExpandedFAQ(expandedFAQ === faqId ? null : faqId);
  };

  const handleRating = (faqId, helpful) => {
    setRatings({ ...ratings, [faqId]: helpful });
  };

  return (
    <div className="space-y-4">
      {faqs?.map((faq) => (
        <div
          key={faq?.id}
          className="bg-card border border-border rounded-xl overflow-hidden transition-all hover:shadow-lg"
        >
          <button
            onClick={() => toggleFAQ(faq?.id)}
            className="w-full px-6 py-4 flex items-center justify-between text-left"
          >
            <div className="flex items-start space-x-4 flex-1">
              <div className={`mt-1 p-2 rounded-lg transition-colors ${
                expandedFAQ === faq?.id ? 'bg-primary/10' : 'bg-muted'
              }`}>
                <Icon 
                  name="HelpCircle" 
                  size={20} 
                  color={expandedFAQ === faq?.id ? 'var(--color-primary)' : 'currentColor'}
                />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-foreground mb-1">
                  {faq?.question}
                </h3>
              </div>
            </div>
            <Icon 
              name={expandedFAQ === faq?.id ? 'ChevronUp' : 'ChevronDown'} 
              size={20} 
              className="text-muted-foreground ml-4"
            />
          </button>

          {expandedFAQ === faq?.id && (
            <div className="px-6 pb-6 border-t border-border">
              <div className="pt-4">
                <p className="text-muted-foreground leading-relaxed mb-6">
                  {faq?.answer}
                </p>

                {faq?.relatedArticles && faq?.relatedArticles?.length > 0 && (
                  <div className="mb-6">
                    <p className="text-sm font-medium text-foreground mb-3">
                      Related Articles:
                    </p>
                    <div className="flex flex-wrap gap-2">
                      {faq?.relatedArticles?.map((article, index) => (
                        <a
                          key={index}
                          href="#"
                          className="text-sm text-primary hover:underline"
                        >
                          {article}
                        </a>
                      ))}
                    </div>
                  </div>
                )}

                <div className="flex items-center justify-between pt-4 border-t border-border">
                  <div className="flex items-center space-x-4">
                    <p className="text-sm text-muted-foreground">Was this helpful?</p>
                    <div className="flex items-center space-x-2">
                      <button
                        onClick={() => handleRating(faq?.id, true)}
                        className={`p-2 rounded-lg transition-colors ${
                          ratings?.[faq?.id] === true
                            ? 'bg-green-500/10 text-green-500' :'hover:bg-muted'
                        }`}
                      >
                        <Icon name="ThumbsUp" size={16} />
                      </button>
                      <button
                        onClick={() => handleRating(faq?.id, false)}
                        className={`p-2 rounded-lg transition-colors ${
                          ratings?.[faq?.id] === false
                            ? 'bg-red-500/10 text-red-500' :'hover:bg-muted'
                        }`}
                      >
                        <Icon name="ThumbsDown" size={16} />
                      </button>
                    </div>
                  </div>

                  <button
                    onClick={() => onBookmark(faq?.id)}
                    className={`flex items-center space-x-2 px-3 py-2 rounded-lg transition-colors ${
                      bookmarkedArticles?.includes(faq?.id)
                        ? 'bg-primary/10 text-primary' :'hover:bg-muted'
                    }`}
                  >
                    <Icon 
                      name={bookmarkedArticles?.includes(faq?.id) ? 'BookmarkCheck' : 'Bookmark'} 
                      size={16} 
                    />
                    <span className="text-sm">
                      {bookmarkedArticles?.includes(faq?.id) ? 'Bookmarked' : 'Bookmark'}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQSection;